// extracted by mini-css-extract-plugin
module.exports = {"options":"styles__options___3w8wf","icon":"styles__icon___143vr"};